import { Locale } from '@/providers/Locale/types'

type TextFields = 'next' | 'previous' | 'restart' | 'listSlides' | 'startSlide' | 'nextSlide' | 'previousSlide'

export const i18n: Record<Locale, Record<TextFields, string>> = {
    en: {
        next: 'Next',
        previous: 'Previous',
        restart: 'Start over',
        listSlides: 'List slides',
        startSlide: 'Start Slideshow',
        previousSlide: 'Previous Slide',
        nextSlide: 'Next Slide',
    },
}
